import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import {  MatDialog } from '@angular/material/dialog';
import { CreDitUsersComponent } from './cre-dit-users/cre-dit-users.component';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ToastrService } from 'ngx-toastr';
import { FormCatalogComponent } from 'src/app/shared/form-catalog/form-catalog.component';
import { UsersService } from '../../shared/service/users/users.service'
import { environment } from 'src/environments/environment';
import { User } from 'src/app/shared/interfaces/user';
import { Rol } from 'src/app/shared/interfaces/rol';
import { Responses } from 'src/app/shared/interfaces/responses';
import { ConfirmDialogData } from 'src/app/shared/interfaces/confirm-dialog-data';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { LoginService } from 'src/app/shared/service/authentication/login.service';
import { fadeInOut, slideInOut, slideInOutbtn } from 'src/app/shared/animations';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  animations: [fadeInOut, slideInOut, slideInOutbtn],
  // providers: [UsersService],
})
export class UsersComponent implements OnInit {

  public users: User[] = [];
  public roles: Rol[] = [];
  public uniqueRoles: string[] = [];

  displayedColumns: string[] = ['number','Rol','Nombre','Nickname','Email','options'];
  dataSource!: MatTableDataSource<User>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  urlBase = environment.urlBase;

  isDesktop = false;
  search = false;
  dataLoaded: boolean = false;
  idUser: number = 0;
  actionFunction!: Function;
  formFilter!: FormGroup;

  constructor(
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private loginService: LoginService,
    private toastrService: ToastrService,
    private usersService: UsersService,
    private fb: FormBuilder
  ) {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .subscribe((result) => {
        this.isDesktop = !result.matches;
      });
    // Verificamos el token del usuario
    this.loginService.verificaAutenticacion().subscribe({
      next: (resp) => {
        this.idUser = resp.data.Id;
      },
    });
    this.formFilter = this.fb.group({
      Estado: ['']  // Valor vacío por defecto = "Todos"
    });
  }

  ngOnInit(): void {
    this.getUsers();
    this.formFilter.get('Estado')?.valueChanges.subscribe(value => {
      this.filterByEstado(value);
    });
  }

  // Abrir el dialog de Agregar/Editar usuario
  public createDialog(user?: User) {
    this.dialog
      .open(CreDitUsersComponent, {
        data: {
          user: user,
          userLoggedIn: this.idUser
        },
        width: '50%',
      })
      .afterClosed()
      .subscribe((confirm: boolean) => {
        if (confirm) {
          this.getUsers();
        } else {
          this.toastrService.warning('Cancelado');
        }
      });
  }

  // Filtro de la tabla de usuarios
  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // Asignamos los datos a la tabla
  private patchMatTableDataSource(users: User[]): void {
    this.dataSource = new MatTableDataSource(users);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // Función que obtiene los usuarios desde la api
  private getUsers(): void {
    this.dataLoaded = true;
    this.usersService.getUsers().subscribe({
      next: (response: Responses) => {
        this.users = response.data;
        // Extraer roles únicos
        this.uniqueRoles = [...new Set(this.users.map(user => (user as any).NombreRol))];
        // Pasamos el array de usuarios a la tabla
        this.patchMatTableDataSource(this.users);
        this.dataLoaded = false;
        this.users.length ? this.toastrService.success(response.message): this.toastrService.warning(response.message);
      },
      error: (error: any) => {
        this.dataLoaded = false;
        this.toastrService.error('Ha ocurrido un error, inténtelo nuevamente.');
      },
    });
  }

  // Componente dialog para eliminar el usuario
  public confirmDeleteUser(user: User): void {
    const data: ConfirmDialogData = {
      width: '550px',
      title: 'Advertencia',
      message: '¿Estas seguro que deseas eliminarlo?',
      name: user.Nombre,
      btnName: 'Confirmar',
    };

    this.dialog
      .open(ConfirmDialogComponent, {
        data: data,
      })
      .afterClosed()
      .subscribe((confirm: Boolean) => {
        if (confirm) {
          this.deleteUser(user);
        } else {
          this.toastrService.warning('Cancelado');
        }
      });
  }

  // Función para eliminar el usuario
  private deleteUser(user: User) {
    this.usersService.deleteUser(user).subscribe({
      next: (response: Responses) => {
        if (response.success) {
          this.toastrService.success(response.message);
          this.getUsers();
        } else {
          this.toastrService.error(response.message);
        }
      },
      error: (err) => {
        this.toastrService.error(err.error.error);
      },
    });
  }
  private filterByEstado(rolNombre: string): void {
    if (!rolNombre || rolNombre === '') {
      // Mostrar todos los usuarios
      this.patchMatTableDataSource(this.users);
    } else {
      // Filtrar por rol
      const filteredUsers = this.users.filter(user => (user as any).NombreRol === rolNombre);
      this.patchMatTableDataSource(filteredUsers);
    }
  }

}



